import AddIncomeModal from './add-income-modal.vue'
export default AddIncomeModal
